<template>
    <div>
        <draggable :list="banners">
            <div v-for="banner of banners" class="banner-image">
                <div class="field has-addons">
                    <p class="control">
                        <span class="icon is-medium">
                            <i class="fas fa-grip-vertical"></i>
                        </span>
                    </p>
                    <p class="control">
                        <input v-model="banner.image" class="input is-small" type="text" placeholder="image" />
                    </p>
                    <p class="control">
                        <input v-model="banner.link" class="input is-small" type="text" placeholder="link" />
                    </p>
                    <p class="control">
                        <a class="button is-small" @click="deleteBanner(banner);">del</a>
                    </p>
                </div>
            </div>
        </draggable>
        <a class="button is-small" @click="addBanner();">add</a>
    </div>
</template>

<script>
    import draggable from "vuedraggable";

    export default {
        name: "client-settings-view-banners",
        components: { draggable },
        props: {
            banners: { required: true, type: Array }
        },
        methods: {
            addBanner() {
                this.banners.push({ image: null, link: null });
            },
            deleteBanner(banner) {
                let index = this.banners.length;
                while (index--) {
                    this.banners[index] === banner && this.banners.splice(index, 1);
                }
            }
        }
    };
</script>

<style lang="scss">
    .banner-image {
        margin-bottom: 0.32rem;
        padding: 0.4rem 0.8rem;
        max-width: 800px;
        border: 1px solid #666;
        border-radius: 0.2rem;
        background-color: #333;
        .icon

    {
        margin-right: 0.2rem;
    }

    div {
        width: 100%;
    }

    input {
        width: 352px;
    }
    }
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/banners-draggable.vue